import { render, staticRenderFns } from "./ClinicalSkillsConfig.vue?vue&type=template&id=c4137532&scoped=true&"
import script from "./ClinicalSkillsConfig.vue?vue&type=script&lang=js&"
export * from "./ClinicalSkillsConfig.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalSkillsConfig.vue?vue&type=style&index=0&id=c4137532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4137532",
  null
  
)

export default component.exports